import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { Element } from "../../../models/elementModel";
import {
  startAddElement,
  startEditElement,
  startRemoveElement,
} from "../../../actions/elementListAction";
import ButtonGroupComponent from "../../utilComponents/buttonGroupComponent";
import produce from "immer";
import "./elementCommonPropertiesPanal.scss";
import Switch from "react-switch";
import { cssStyle } from "../../../models/cssStyleModel";
import { uuid } from "uuidv4";
import chamalCasingCss from "./commonPropertyUtil/chamalCasingCss";
import { Tooltip } from "react-tippy";

export interface ElementStylePropertiesProps {
  element: Element;
}

const ElementStyleProperties: FC<ElementStylePropertiesProps> = ({
  element,
}) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const addNewCssStyle = () => {
    let newCssStyle: cssStyle = {
      id: uuid(),
      style: "",
      retrivedStyle: "",
      value: "",
    };
    const newElement = produce(element, (draft) => {
      draft.properties.cssStyles.push(newCssStyle);
    });
    dispatch(startEditElement(newElement));
  };

  const removeCssStyle = (index: number) => {
    const newElement = produce(element, (draft) => {
      draft.properties.cssStyles.splice(index, 1);
    });
    dispatch(startEditElement(newElement));
  };

  return (
    <div className="container ">
      {element.type !== "input" &&
        element.type != "file" &&
        element.type != "txtarea" &&
        element.type != "dropdown" &&
        element.type != "navbar" &&
        element.type !== "typography" && (
          <>
            <div className="form-group row">
              <label
                htmlFor="text-align"
                className="col-sm-4 col-form-label font-size-12 align-text-left"
              >
                Text Align
              </label>
            </div>
            <div className="form-group row">
              <div className="col-sm-3">
              <Tooltip title="Text Align Left">
                <button
                  className={`form-control btn-dark btn-theam ${
                    element.styles.textAlign === "left" ? "btn-active" : ""
                  }`}
                  id="alignLeft"
                  onClick={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.styles.textAlign = "left";
                    });
                    dispatch(startEditElement(newElement));
                  }}
                >
                  <i className="fa fa-align-left"></i>
                </button>
                </Tooltip>
              </div>
              <div className="col-sm-3">
              <Tooltip title="Text Align Center">
                <button
                  className={`form-control btn-dark btn-theam ${
                    element.styles.textAlign === "center" ? "btn-active" : ""
                  }`}
                  id="alignCenter"
                  onClick={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.styles.textAlign = "center";
                    });
                    dispatch(startEditElement(newElement));
                  }}
                >
                  <i className="fa fa-align-center"></i>
                </button>
                </Tooltip>
              </div>
              <div className="col-sm-3">
              <Tooltip title="Text Align Right">
                <button
                  className={`form-control btn-dark btn-theam ${
                    element.styles.textAlign === "end" ? "btn-active" : ""
                  }`}
                  id="alignRight"
                  onClick={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.styles.textAlign = "end";
                    });
                    dispatch(startEditElement(newElement));
                  }}
                >
                  <i className="fa fa-align-right"></i>
                </button>
                </Tooltip>
              </div>
              <div className="col-sm-3">
              <Tooltip title="Text Align Justify">
                <button
                  className={`form-control btn-dark btn-theam ${
                    element.styles.textAlign === "justify" ? "btn-active" : ""
                  }`}
                  id="alignJustify"
                  onClick={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.styles.textAlign = "justify";
                    });
                    dispatch(startEditElement(newElement));
                  }}
                >
                  <i className="fa fa-align-justify"></i>
                </button>
                </Tooltip>
              </div>
            </div>
          </>
        )}
      {(element.type === "input" ||
        element.type === "file" ||
        element.type === "txtarea" ||
        element.type === "dropdown" ||
        element.type === "navbar" ||
        element.type === "typography" ||
        element.type === "collaps" ||
        element.type === "table") && (
        <>
          <div className="form-group row">
            <label
              htmlFor="flex"
              className="col col-form-label font-size-12 align-text-left"
            >
              Content Align
            </label>
          </div>
          <div className="form-group row">
            <div className="col">
            <Tooltip title="Content Align Left">
              <button
                className={`form-control btn-dark btn-theam ${
                  element.properties.justifyContent === "flex-start"
                    ? "btn-active"
                    : ""
                }`}
                id="alignLeft"
                onClick={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.flex = "flex";
                    draft.properties.justifyContent = "flex-start";
                  });
                  dispatch(startEditElement(newElement));
                }}
              >
                <i className="fa fa-align-left"></i>
              </button>
              </Tooltip>
            </div>
            <div className="col">
            <Tooltip title="Content Align Center">
              <button
                className={`form-control btn-dark btn-theam ${
                  element.properties.justifyContent === "center"
                    ? "btn-active"
                    : ""
                }`}
                id="alignCenter"
                onClick={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.flex = "flex";
                    draft.properties.justifyContent = "center";
                  });
                  dispatch(startEditElement(newElement));
                }}
              >
                <i className="fa fa-align-center"></i>
              </button>
              </Tooltip>
            </div>
            <div className="col">
              <Tooltip title="Content Align Right">
              <button
                className={`form-control btn-dark btn-theam ${
                  element.properties.justifyContent === "flex-end"
                    ? "btn-active"
                    : ""
                }`}
                id="alignRight"
                onClick={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.flex = "flex";
                    draft.properties.justifyContent = "flex-end";
                  });
                  dispatch(startEditElement(newElement));
                }}
              >
                <i className="fa fa-align-right"></i>
              </button>
              </Tooltip>
            </div>
            <div className="col">
              <Tooltip title="Reset">
              <button
                className={`form-control btn-dark btn-theam`}
                id="reset"
                onClick={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.flex = "";
                    draft.properties.justifyContent = "";
                  });
                  dispatch(startEditElement(newElement));
                }}
              >
                <i className="fa fa-repeat"></i>
              </button>
              </Tooltip>
            </div>
          </div>
        </>
      )}
      {!(
        element.type === "rdioBtn" ||
        element.type === "chkBox" ||
        element.type === "heading" ||
        element.type === "lbl"
      ) && (
        <>
          {element.type !== "collaps" && (
            <div className="form-group row">
              <label
                htmlFor="height"
                className="col-sm-4 col-form-label font-size-12 align-text-left"
              >
                Height
              </label>
              <div className="col-sm-7">
                <input
                  type="text"
                  className="form-control theam-textbox items-align-left"
                  id="height"
                  value={element.styles.height}
                  onChange={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.styles.height = e.target.value;
                    });
                    dispatch(startEditElement(newElement));
                  }}
                />
              </div>
              <span className="font-size-12"> px</span>
            </div>
          )}
          <div className="form-group row">
            <label
              htmlFor="width"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Width
            </label>
            <div className="col-sm-7">
              <input
                type="text"
                className="form-control theam-textbox items-align-left"
                id="width"
                value={element.styles.width}
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.styles.width = e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
              />
            </div>
            <span className="font-size-12"> px</span>
          </div>
        </>
      )}
      <div className="form-group row">
        <label
          htmlFor="margine"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Margin
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.isMarginAll}
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.isMarginAll = e;
              });
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="margine"
          />
        </div>
        <div className="col-sm-3 mt-1 font-size-12"> All</div>
      </div>
      {element.properties.isMarginAll && (
        <div className="row form-group">
          <div className="col-sm-4"></div>
          <div className="col-sm-7">
            <input
              type="number"
              className="form-control theam-textbox"
              id="margin"
              value={element.styles.margin}
              onChange={(e) => {
                const newElement = produce(element, (draft) => {
                  draft.styles.margin = e.target.value;
                });
                dispatch(startEditElement(newElement));
              }}
            />
          </div>
          <span className="font-size-12">px</span>
        </div>
      )}
      {!element.properties.isMarginAll && (
        <>
          <div className="form-group row">
            <div className="col rigth-margin-0">
              <input
                type="number"
                className="form-control theam-textbox"
                id="margin-top"
                value={element.styles.marginTop}
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.styles.marginTop = e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
              />
            </div>
            <div className="col rigth-margin-0">
              <input
                type="number"
                className="form-control theam-textbox"
                id="margin-bottom"
                value={element.styles.marginBottom}
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.styles.marginBottom = e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
              />
            </div>
            <div className="col rigth-margin-0">
              <input
                type="number"
                className="form-control theam-textbox"
                id="margin-right"
                value={element.styles.marginRight}
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.styles.marginRight = e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
              />
            </div>
            <div className="col rigth-margin-0">
              <input
                type="number"
                className="form-control theam-textbox"
                id="margin-left"
                value={element.styles.marginLeft}
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.styles.marginLeft = e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="margin-top"
              className="col col-form-label font-size-12 rigth-margin-0"
            >
              Top
            </label>
            <label
              htmlFor="margin-bottom"
              className="col col-form-label font-size-12 rigth-margin-0"
            >
              Bottom
            </label>
            <label
              htmlFor="margin-right"
              className="col col-form-label font-size-12 rigth-margin-0"
            >
              Right
            </label>
            <label
              htmlFor="margin-left"
              className="col col-form-label font-size-12 rigth-margin-0"
            >
              Left
            </label>
          </div>
        </>
      )}
      <h6>Advance Style Properties</h6>
      <div className="form-group col-12 m-2 p-2">
        <button
          type="button"
          className="btn btn-dark btn-sm font-size-12"
          onClick={addNewCssStyle}
        >
          <i className="fa fa-plus"></i>
        </button>
      </div>

      {element.properties.cssStyles.map((_style: cssStyle, i: number) => {
        return (
          <div key={i}>
            <div className="form-group row">
              <div className="col-sm-10"></div>
              <div className="col-sm-2">
                <button
                  type="button"
                  className="btn btn-dark btn-sm font-size-12"
                  onClick={(e) => removeCssStyle(i)}
                >
                  <i className="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-sm-5 noPadding">
                <input
                  type="text"
                  className="form-control theam-textbox"
                  id={`style${i}`}
                  value={_style.style}
                  placeholder="Css Property"
                  onChange={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.properties.cssStyles[i].style = e.target.value;
                      draft.properties.cssStyles[i].retrivedStyle =
                        chamalCasingCss(e.target.value);
                    });
                    dispatch(startEditElement(newElement));
                  }}
                />
              </div>
              <div className="col-sm-1 noPadding">:</div>
              <div className="col-sm-6 noPadding">
                <input
                  type="text"
                  className="form-control theam-textbox"
                  id={`value${i}`}
                  value={_style.value}
                  placeholder="Enter Value"
                  onChange={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.properties.cssStyles[i].value = e.target.value;
                    });
                    dispatch(startEditElement(newElement));
                  }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ElementStyleProperties;
